import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import ContactForm from "@/components/site/ContactForm";
import StaggerWords from "@/components/site/StaggerWords";

export default function Contact() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [120, -40]);

  return (
    <section
      id="contact"
      ref={ref}
      data-testid="contact-section"
      className="bg-ink relative overflow-hidden border-t border-ink-border"
    >
      {/* Connecting rail */}
      <div aria-hidden className="absolute left-3 md:left-6 top-0 bottom-0 w-px bg-[#E04F2A]/25 z-0" />
      <div aria-hidden className="absolute left-[10px] md:left-[19px] top-32 md:top-48 -translate-x-1/2 h-2.5 w-2.5 rounded-full border border-[#E04F2A] bg-ink z-0" />
      <motion.div style={{ y }} className="px-6 md:px-12 py-32 md:py-48 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-baseline gap-4 mb-12">
            <span className="font-manrope text-xs uppercase tracking-[0.3em] text-bone/60 inline-flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#E04F2A]" />
              04 · Contact
            </span>
            <span className="h-px flex-1 bg-bone/15" />
          </div>

          <h2
            data-testid="contact-headline"
            className="font-oswald uppercase tracking-tighter leading-[0.85] text-bone text-7xl md:text-9xl lg:text-[14vw]"
          >
            <StaggerWords text="Let's" />{" "}
            <StaggerWords text="talk." delay={0.15} />
          </h2>

          <p className="mt-8 font-cormorant italic text-2xl md:text-3xl text-bone/80 max-w-xl">
            Have a project in mind? Tell me the idea and let's build something memorable.
          </p>

          <div className="mt-16 border-t border-ink-border" />

          <ContactForm />
        </div>
      </motion.div>
    </section>
  );
}
